export const CCPA_ANALYTICS = "ohio_squeeze_analytics";
export const CCPA_MARKETING = "ohio_squeeze_marketing";
export const CCPA_PERSONALIZATION = "ohio_squeeze_personalization";
